// extracted by mini-css-extract-plugin
module.exports =  {"visuallyHidden":"visuallyHidden_F9KCxGKy"};